// File: components/intellectualSection/IntellectualSection.jsx

import React from "react";
import "./IntellectualSection.css";

import bookImage1 from "../../Assets/images/bold.jpeg";
import bookImage2 from "../../Assets/images/book3.jpeg";
import bookImage3 from "../../Assets/images/sister-love.jpeg";
import bookImage4 from "../../Assets/images/incredible.jpeg";


const ideas = [
  {
    title: "A Bold New Attitude",
    image: bookImage1,
    description:
      "A transformational leadership framework focused on mindset renewal, personal growth, strategic influence, and sustainable impact across generations."
  },

  {
    title: "Sin-Seer Leadership",
    image: bookImage2,
    description:
      "An advanced leadership philosophy exploring discernment, ethical influence, governance systems, and visionary leadership development."
  },
  {
    title: "Sister Love",
    image: bookImage3,
    description:
      "A Story about Empathy, Forgiveness and Peace."
  },
  {
    title: "The Incredible Footballers",
    image: bookImage4,
    description:
      "The Greatest Football match ever imagined"
  },

  
];

const IntellectualSection = () => {
  return (
    <section className="intellectual-section">

      <div className="intellectual-container">

        {/* HEADER */}
        <div className="intellectual-header">

          <span className="intellectual-tag">
            Intellectual Platforms
          </span>

          <h2 className="intellectual-title">
            Books, Ideas & Transformational Systems
          </h2>

          <p className="intellectual-subtitle">
            Each intellectual property within Ample House is designed as a
            structured ecosystem — evolving into books, learning systems,
            leadership frameworks, and global education platforms.
          </p>

        </div>

        {/* GRID */}
        <div className="intellectual-grid">

          {ideas.map((idea, index) => (
            <div className="intellectual-card" key={index}>

              <div className="book-image-container">
                <img
                  src={idea.image}
                  alt={idea.title}
                  className="book-image"
                />
              </div>

              <div className="card-content">
                <h3 className="card-title">{idea.title}</h3>
                <p className="card-description">{idea.description}</p>
              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default IntellectualSection;